<script setup lang="ts">
import ConfirmDialog from "./ConfirmDialog.vue";
import { useConfirm } from "../composables/useConfirm";

const { state, finish } = useConfirm();
</script>

<template>
  <ConfirmDialog
    :open="state.open"
    :title="state.title"
    :message="state.message"
    :confirm-label="state.confirmLabel"
    @cancel="finish(false)"
    @confirm="finish(true)"
  />
</template>
